import NoSleep from 'nosleep.js'
import { faExpand } from '@fortawesome/free-solid-svg-icons'
import { cn } from '@/utils'

import { RundownOutputControlButton } from '@/features/rundown-output/RundownOutputControlButton'

type RundownOutputControlsTypes = {
  mirrorVertically: boolean
  onMirrorVertically: () => void
  mirrorHorizontally: boolean
  onMirrorHorizontally: () => void
}

const noSleep = new NoSleep()

function toggleFullscreen() {
  if (!document.fullscreenElement) {
    // If the document is not currently in fullscreen mode
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen()
    } else if (document.documentElement.mozRequestFullScreen) {
      // Firefox
      document.documentElement.mozRequestFullScreen()
    } else if (document.documentElement.webkitRequestFullscreen) {
      // Chrome, Safari and Opera
      document.documentElement.webkitRequestFullscreen()
    } else if (document.documentElement.msRequestFullscreen) {
      // IE/Edge
      document.documentElement.msRequestFullscreen()
    }
    noSleep.enable()
  } else {
    // If the document is already in fullscreen mode, exit fullscreen
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen()
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen()
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen()
    }
    noSleep.disable()
  }
}

export function RundownOutputControls({
  mirrorVertically,
  onMirrorVertically,
  mirrorHorizontally,
  onMirrorHorizontally,
}: RundownOutputControlsTypes) {
  return (
    <div className="flex gap-1">
      <button
        className={cn([
          'h-10 w-10 rounded bg-gray-800/90 hover:bg-gray-800 transition-colors flex items-center justify-center',
          mirrorVertically && 'border border-green-500',
        ])}
        onClick={onMirrorVertically}
      >
        <img className="h-6 w-6 text-white" src="/img/mirror-icon.svg" />
      </button>
      <button
        className={cn([
          'h-10 w-10 rounded bg-gray-800/90 hover:bg-gray-800 transition-colors flex items-center justify-center',
          mirrorHorizontally && 'border border-green-500',
        ])}
        onClick={onMirrorHorizontally}
      >
        <img
          className="h-6 w-6 text-white rotate-90"
          src="/img/mirror-icon.svg"
        />
      </button>
      <RundownOutputControlButton
        tooltip="Toggle fullscreen"
        icon={faExpand}
        onClick={toggleFullscreen}
      />
    </div>
  )
}
